import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";
import {AuthenticationService} from "../../services/authentication.service";
import {AlertService} from "../../services/alert.service";
import {SettingsService} from "../../services/settings.service";
import {LoaderService} from "../../services/loader.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-rate-calculator',
  templateUrl: './rate-calculator.component.html',
  styleUrls: ['./rate-calculator.component.css']
})
export class RateCalculatorComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([0-9])?)$';
  private rateCalcForm;
  private settingsList;
  private selectedSettingsList;
  private consignmentList;
  private loading = false;
  private chargeType = 'Weight';

  constructor(private formBuilder:FormBuilder,
              private alertService:AlertService,
              private settingsService:SettingsService,
              private loaderService:LoaderService) {
  }

  ngOnInit() {
    this.rateCalcForm = this.formBuilder.group({

      consignment_type: ['', Validators.required],
      weight: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
      weight_charges: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
      length: [''],
      width: [''],
      height: [''],
      valuation: [''],
      valuation_charge: [''],
      insured: [''],
      insurance_charge: ['', Validators.pattern(this.moneyRegex)],
      pod: [''],
      pod_charge: ['', Validators.pattern(this.moneyRegex)],
      igst_rate: [''],
      igst_amount: ['', Validators.pattern(this.moneyRegex)],
      cgst_rate: [''],
      cgst_amount: ['', Validators.pattern(this.moneyRegex)],
      sgst_rate: [''],
      sgst_amount: ['', Validators.pattern(this.moneyRegex)],
      net_amount: ['', Validators.pattern(this.moneyRegex)],
      total_charge: ['', Validators.pattern(this.moneyRegex)]
    });
    this.getSettingsData();
    this.getConsignmentData();

    this.rateCalcForm.controls['weight'].valueChanges.subscribe(value => {
      this.weightChanged();
    });
    this.rateCalcForm.controls['length'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.rateCalcForm.controls['width'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.rateCalcForm.controls['height'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.rateCalcForm.controls['igst_rate'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['sgst_rate'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['cgst_rate'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['weight_charges'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['pod_charge'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['valuation_charge'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
    this.rateCalcForm.controls['insurance_charge'].valueChanges.subscribe(value => {
      this.chargesChanged();
    });
  }

  getConsignmentData() {
    this.settingsService.consignmentList().subscribe(
      data => {
        this.consignmentList = data || [];
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  getSettingsData() {
    this.settingsService.getSettings().subscribe(
      data => {
        this.settingsList = data || [];
        this.onConsignmentTypeChange();
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  onConsignmentTypeChange() {
    this.selectedSettingsList = this.settingsList.find(s=>s.consignment_type == this.rateCalcForm.controls['consignment_type'].value);
    var data = this.selectedSettingsList ? {
      igst_rate: this.selectedSettingsList.igst_rate,
      cgst_rate: this.selectedSettingsList.cgst_rate,
      sgst_rate: this.selectedSettingsList.sgst_rate
    } : {
      igst_rate: '',
      cgst_rate: '',
      sgst_rate: ''
    };
    data ? this.rateCalcForm.patchValue(data) : null;
    this.weightChanged();
    this.volumeUnitChanged();
  }

  volumeUnitChanged() {
    var weight = ((this.rateCalcForm.controls.length.value && this.rateCalcForm.controls.length.valid ? parseFloat(this.rateCalcForm.controls.length.value) : 0)
      * (this.rateCalcForm.controls.width.value && this.rateCalcForm.controls.width.valid ? parseFloat(this.rateCalcForm.controls.width.value) : 0)
      * (this.rateCalcForm.controls.height.value && this.rateCalcForm.controls.height.valid ? parseFloat(this.rateCalcForm.controls.height.value) : 0)) / 5;
    this.selectedSettingsList ? this.rateCalcForm.patchValue({weight: weight || 0}) : null;
  }

  weightChanged() {
    this.selectedSettingsList ? this.rateCalcForm.patchValue({weight_charges: this.getAppropriateWeightRangeRateFromArray(this.rateCalcForm.controls.weight.value || 0)}) : 0;
  }

  getAppropriateWeightRangeRateFromArray(weight) {
    var charge = 0;
    this.selectedSettingsList.weight_range_rate.forEach(rate=> {
      rate.end != '+' ? rate.start <= weight && rate.end >= weight ? charge = rate.amount : null : null;
      rate.end == '+' ? rate.start <= weight ? charge = rate.amount : null : null;
    });
    return charge * weight;
  }

  chargesChanged():void {
    var total = 0;
    this.rateCalcForm.controls.weight_charges.value && this.rateCalcForm.controls.weight_charges.valid ? total += parseFloat(this.rateCalcForm.controls.weight_charges.value) : null;
    this.rateCalcForm.controls.valuation_charge.value && this.rateCalcForm.controls.valuation_charge.valid ? total += parseFloat(this.rateCalcForm.controls.valuation_charge.value) : null;
    this.rateCalcForm.controls.pod_charge.value && this.rateCalcForm.controls.pod_charge.valid ? total += parseFloat(this.rateCalcForm.controls.pod_charge.value) : null;
    this.rateCalcForm.controls.insurance_charge.value && this.rateCalcForm.controls.insurance_charge.valid ? total += parseFloat(this.rateCalcForm.controls.insurance_charge.value) : null;
    this.rateCalcForm.patchValue({total_charge: total});
    this.rateCalcForm.controls.igst_rate.value && this.rateCalcForm.controls.igst_rate.valid ? this.rateCalcForm.patchValue({igst_amount: ((total * this.rateCalcForm.controls.igst_rate.value) / 100)}) : this.rateCalcForm.patchValue({igst_amount: ''});
    this.rateCalcForm.controls.cgst_rate.value && this.rateCalcForm.controls.cgst_rate.valid ? this.rateCalcForm.patchValue({cgst_amount: ((total * this.rateCalcForm.controls.cgst_rate.value) / 100)}) : this.rateCalcForm.patchValue({cgst_amount: ''});
    this.rateCalcForm.controls.sgst_rate.value && this.rateCalcForm.controls.sgst_rate.valid ? this.rateCalcForm.patchValue({sgst_amount: ((total * this.rateCalcForm.controls.sgst_rate.value) / 100)}) : this.rateCalcForm.patchValue({sgst_amount: ''});
    this.rateCalcForm.patchValue({net_amount: (total + (this.rateCalcForm.controls.igst_amount.value || 0))});
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/rate-calculator/rate-calculator.component.ts